/* Belgrave Club theme scripts */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '£{{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* Product form: variant picker, gallery, quantity, sticky add to cart */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-bc-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format');
    var form = root.querySelector('form.bc-product-form');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-bc-price]');
    var compareEl = root.querySelector('[data-bc-compare]');
    var buttons = root.querySelectorAll('[data-bc-add]');
    var stickyPrice = document.querySelector('[data-bc-sticky-price]');
    var mainImg = root.querySelector('[data-bc-main-wrap] img');
    var thumbs = root.querySelectorAll('[data-bc-thumb]');
    var labels = root.querySelectorAll('[data-bc-option-label]');

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('fieldset[data-bc-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    function showMedia(src, srcset, alt, thumbId) {
      if (!mainImg || !src) return;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      if (alt) mainImg.alt = alt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-id') === String(thumbId) ? 'true' : 'false'); });
    }

    function update() {
      var opts = selectedOptions();
      labels.forEach(function (l, i) { l.textContent = opts[i] || ''; });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      buttons.forEach(function (b) {
        if (!variant) { b.disabled = true; b.textContent = b.getAttribute('data-unavailable'); return; }
        b.disabled = !variant.available;
        b.textContent = variant.available ? b.getAttribute('data-label') : b.getAttribute('data-soldout');
      });
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (variant.featured_media && variant.featured_media.preview_image) {
        var thumb = root.querySelector('[data-bc-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) { thumb.click(); }
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('fieldset[data-bc-option] input').forEach(function (input) {
      input.addEventListener('change', update);
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        showMedia(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-alt'), t.getAttribute('data-media-id'));
      });
    });

    var qty = root.querySelector('[data-bc-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-step'), 10);
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
        });
      });
    }

    var sticky = document.querySelector('[data-bc-sticky-atc]');
    var mainButton = root.querySelector('[data-bc-add="main"]');
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(mainButton);
      var stickyBtn = sticky.querySelector('[data-bc-add="sticky"]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }

    update();
  }

  /* Product recommendations (loaded via Section Rendering API) */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-bc-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* Collection sorting */
  function initSort(select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bc-product]').forEach(initProduct);
    document.querySelectorAll('[data-bc-recommendations][data-url]').forEach(initRecommendations);
    document.querySelectorAll('[data-bc-sort]').forEach(initSort);
  });
})();
